<template>
  <v-card outlined>
    <v-card-text>
      {{ label }}
      <v-row>
        <v-col cols=12 md="9">
          <v-text-field
            :label="inputLabel != null ? inputLabel : $t('core.list.add_string')"
            v-model="string"
            :rules="requiredRules"
          />
        </v-col>
        <v-col cols=12 md="3" class="d-flex">
          <v-btn color="primary" @click="addString" class="plus-btn">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-list-item-group>
        <v-list-item v-for="(string, i) in strings" :key="i">
          <v-list-item-icon>
            <v-icon @click="removeString(i)">mdi-minus</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="string" />
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'List',

  data: () => ({
    string: ''
  }),

  model: {
    prop: 'strings',
    event: 'click'
  },

  props: {
    label: {
      type: String,
      default: ''
    },
    strings: {
      type: Array,
      default: () => []
    },
    inputLabel: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    requiredRules () {
      return this.required ? [this.strings.length > 0 || this.$t('warnings.validation.required')] : []
    }
  },

  methods: {
    addString () {
      this.strings.push(this.string)
      this.string = ''
      this.$emit('click', this.strings)
    },

    removeString (i) {
      this.strings.splice(i, 1)
      this.$emit('click', this.strings)
    }
  }
}
</script>
<style scoped>
  .d-flex {
    display: flex;
  }
  .plus-btn {
    margin: auto auto auto 0;
  }
</style>
